import { useState, useCallback } from 'react';
export const usePendingContactEmailUpdates = ()=>{
    const [pendingUserIds, setPendingUserIds] = useState(new Set());
    const isPending = useCallback((userId)=>pendingUserIds.has(userId), [
        pendingUserIds
    ]);
    const markPending = useCallback((userId)=>{
        setPendingUserIds((prev)=>new Set(prev).add(userId));
    }, []);
    const markComplete = useCallback((userId)=>{
        setPendingUserIds((prev)=>{
            const next = new Set(prev);
            next.delete(userId);
            return next;
        });
    }, []);
    return {
        isPending,
        markPending,
        markComplete
    };
};
